interface CouponBrand<TProduct extends object> {
  brandName: string;
  products: TProduct[];
}

export const resolveCouponProducts = <TProduct extends object>(
  brands: CouponBrand<TProduct>[],
  selectedBrandName: string | null,
  limit: number,
) =>
  brands
    .filter(
      ({ brandName }) =>
        selectedBrandName === null || brandName === selectedBrandName,
    )
    .flatMap(({ brandName, products }) =>
      products.map((product) => ({ ...product, brandName })),
    )
    .slice(0, limit);
